import React from 'react';

// One empty state for the whole site: line icon in a soft circle, a title, a hint,
// and an optional button (e.g. "Show all games" when a quick filter hides everything).
const ICONS = {
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /><path d="M9.5 15.5l5-3M9.5 12.5l5 3" /></>,
  ticket: <><path d="M3 7h18v4a2 2 0 0 0 0 4v4H3v-4a2 2 0 0 0 0-4z" /><path d="M13 7v12" strokeDasharray="2 2" /></>,
  history: <><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v5h5" /><path d="M12 8v4l3 2" /></>,
  flag: <><path d="M5 21V4" /><path d="M5 4h13l-2.5 4L18 12H5" /></>,
  loading: <><path d="M12 3a9 9 0 1 0 9 9" /></>,
};

export default function EmptyState({ icon = 'calendar', title, hint, action, onAction }) {
  return (
    <div className="es-card">
      <span className={`es-icon${icon === 'loading' ? ' spin' : ''}`}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{ICONS[icon]}</svg>
      </span>
      <b className="es-title">{title}</b>
      {hint && <span className="es-hint">{hint}</span>}
      {action && <button type="button" className="es-btn" onClick={onAction}>{action}</button>}
    </div>
  );
}
